module.exports = __webpack_public_path__ + "static/media/my_policies.876487b4.svg";